import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_Page = _resolveComponent("Page")!
  const _component_authenticated_layout = _resolveComponent("authenticated-layout")!

  return (_openBlock(), _createBlock(_component_authenticated_layout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_Page, {
          hideHeaderForLarge: true,
          title: _ctx.pageTitle,
          navItems: _ctx.navItemConfig,
          activeItem: _ctx.activeNavItem.url
        }, {
          header: _withCtx(() => [
            _createVNode(_component_Avatar, {
              image: _ctx.user?.profileImage,
              text: _ctx.avatarFallbackText,
              variant: _ctx.avatarVariant,
              icon: _ctx.avatarIcon
            }, null, 8, ["image", "text", "variant", "icon"])
          ]),
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComponent), {
              model: _ctx.model,
              valid: _ctx.isValid,
              hideComplete: _ctx.tryingSetup,
              onUpdate: _ctx.handleUpdate,
              onSaveCustomisation: _ctx.handleSaveCustomisation
            }, {
              "customise-title": _withCtx(() => [
                _createElementVNode("h4", null, [
                  _createVNode(_component_TranslatedText, {
                    path: _ctx.activeNavItem.title
                  }, null, 8, ["path"])
                ]),
                _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1))
              ]),
              _: 1
            }, 40, ["model", "valid", "hideComplete", "onUpdate", "onSaveCustomisation"]))
          ]),
          _: 1
        }, 8, ["title", "navItems", "activeItem"])
      ])
    ]),
    _: 1
  }))
}